import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const CorrugatedPlasticSign = () => {

    const servicesFaqData = [
        {
            question: "What are corrugated plastic signs, and how are they used?",
            answer: "Corrugated plastic signs are lightweight, durable signs made of weather-resistant material. They are commonly used for outdoor advertising, directional signage, event promotions, and real estate marketing."
        },
        {
            question: "What are the benefits of large corrugated plastic signs printing?",
            answer: "Large corrugated plastic signs printing offers high visibility and durability, making them ideal for long-term promotions, events, and advertising. Their lightweight design ensures easy installation and portability."
        },
        {
            question: "Can Printingy handle bulk orders for custom corrugated plastic signs?",
            answer: "Yes, Printingy specialises in bulk custom corrugated plastic signs printing. We ensure consistent quality, cost-effective pricing, and timely delivery for large-scale orders."
        },
        {
            question: "What customisation options are available for corrugated plastic signs?",
            answer: "Printingy offers full customisation for corrugated plastic sign printing, including sizes, colours, designs, and finishes. You can add logos, text, and graphics to create signage that aligns with your branding needs."
        },
        {
            question: "Are corrugated plastic signs suitable for outdoor use?",
            answer: "Absolutely. Our corrugated plastic sign printing services use weather-resistant materials that withstand sun, rain, and wind, ensuring long-lasting and fade-resistant performance for outdoor applications."
        },
        {
            question: "How durable are corrugated plastic signs?",
            answer: "Corrugated plastic signs are made from sturdy, lightweight materials that are durable and impact-resistant. This makes them perfect for outdoor signage, real estate signs, and event promotions."
        },
        {
            question: "What industries benefit from corrugated plastic signs printing?",
            answer: "Industries such as real estate, events, retail, education, and construction use corrugated plastic sign printing services for advertising, promotions, and directional signage due to their cost-effectiveness and durability."
        },
        {
            question: "What is the turnaround time for bulk corrugated plastic signs?",
            answer: "Standard bulk orders for printing of corrugated plastic signs are typically completed within a few business days. We ensure efficient production and on-time delivery for all projects."
        },
        {
            question: "Can I include custom designs or branding on corrugated plastic signs?",
            answer: "Yes, our custom corrugated plastic signs printing allows you to add logos, graphics, and messaging. We ensure high-quality prints with vibrant colours and sharp visuals for impactful signage."
        },
        {
            question: "How do I place an order for corrugated plastic sign printing?",
            answer: "Placing an order is simple. Visit our website, select your specifications for corrugated plastic sign printing, upload your artwork, and confirm your details. Our team will guide you through the process to ensure seamless delivery."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Corrugated Plastic Sign');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Corrugated Plastic Sign Printing Services"
  description="Professional printing of corrugated plastic signs for events and promotions. Bulk custom corrugated plastic sign printing services for durable and large signage."
  keywords="Printing of Corrugated Plastic Sign,
Corrugated Plastic Sign Printing,
Custom Corrugated Plastic Signs Printing,
Corrugated Plastic Sign Printing Services,
Large Corrugated Plastic Signs Printing

"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Corrugated Plastic Signs</h1>
              <h2 className="text-muted">
              Durable and large corrugated plastic signs for branding and promotions
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Corrugated plastic signs are a cost-effective, durable solution for outdoor advertising, events, and promotional displays. Printingy specialises in Printing of Corrugated Plastic Signs, offering high-quality corrugated plastic sign printing tailored for bulk orders.</p>
          <p>Our custom corrugated plastic signs printing solutions are ideal for businesses needing lightweight, weather-resistant signage that delivers sharp visuals and long-lasting impact. Whether for directional signage, real estate advertising, or event promotions, we guarantee precision, consistency, and vibrant prints.</p>
          <p>From small-scale campaigns to large corrugated plastic signs printing, Printingy ensures cost-effective solutions with premium materials and advanced printing technology.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Corrugated Plastic Sign Printing Solutions</h2>
                <h3 className="large-hed">High-quality, durable, and custom signs for versatile use</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert printing of corrugated plastic sign for outdoor and indoor applications.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional corrugated plastic sign printing for vibrant and sharp visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored custom corrugated plastic signs printing to meet your branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Affordable large corrugated plastic signs printing for events and campaigns.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable, lightweight, and weather-resistant materials for long-term use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology ensuring precise and fade-resistant graphics.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for businesses, real estate, and event organisers.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/corrugated.jpg" // Path relative to the public folder
                  alt="Large corrugated plastic signs printing for events"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
        title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Corrugated Plastic Signs Delivered On Time</h2>
            <h3 className="small-hed">Focus on your advertising while we manage your sign printing needs</h3>
            <p>At Printingy, we deliver premium corrugated plastic sign printing services using high-quality materials and advanced printing techniques. Our durable and lightweight custom corrugated plastic signs printing solutions ensure long-lasting visuals, making them perfect for promotions, events, and directional displays.</p>
            <p>We prioritise precision and quick delivery for all bulk orders, ensuring your signage reaches you on time and meets the highest quality standards. Partner with Printingy for reliable and impactful plastic signage solutions.</p>
          </div>
        </Container>
      </section>



      <div>
 
  <OtherServicesCarousel />
 
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default CorrugatedPlasticSign;
